import TheGrid from '@/views/stars/ws_relations/grid'
import Edit from '@/views/stars/ws_relations/edit'
import Importer from '@/views/stars/ws_relations/import'

export default {
  path: '/stars/ws_relations',
  redirect: '/stars/ws_relations/index',
  name: 'ws_relations',
  meta: {
    auth: {
      redirect: {
        name: 'ws_relations.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'WS Relations'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'ws_relations.index',
    component: TheGrid,
    meta: {
      auth: true,
      roles: ['SUPER','UFS'],
      forbiddenRedirect: '/dashboard',
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'ws_relations.create',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER','UFS'],
      forbiddenRedirect: '/dashboard',
      label: 'Criar'
    }
  }, {
    path: 'import',
    name: 'ws_relations.import',
    component: Importer,
    meta: {
      auth: true,
      roles: ['SUPER','UFS'],
      forbiddenRedirect: '/dashboard',
      label: 'Importar'
    }
  }, {
    path: 'edit/:id',
    name: 'ws_relations.edit',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER','UFS'],
      forbiddenRedirect: '/dashboard',
      label: 'Editar'
    }
  }]
}
